export const FIRST_LAST = 'FIRST_LAST';
export const LAST_FIRST = 'LAST_FIRST';
export const EDGES_CENTER = 'EDGES_CENTER';
export const CENTER_EDGES = 'CENTER_EDGES';
export const RANDOM = 'RANDOM';
